module.exports = __webpack_public_path__ + "static/media/split_pricing_example.254f2d76.png";